import "@/styles/globals.css";
import { BuyProvider } from "@/context/buy";
import { LoadingProvider } from "@/context/loading";
import { MusicProvider } from "@/context/music";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useLoading } from "@/context/loading";
import withBaseUrl from "@/Utils/const";
import Head from "next/head";
import { Toaster } from "react-hot-toast";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-phone-input-2/lib/style.css";
import GlobalMusicPlayer from "@/Components/User/Common/GlobalMusicPlayer";

function LoadingWrapper({ children }) {
  const router = useRouter();
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const handleStart = () => {
      startLoading("Loading page...");
    };

    const handleStop = () => {
      setTimeout(() => {
        stopLoading();
      }, 500);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router]);

  return children;
}

export default function App({ Component, pageProps }) {
  return (
    <LoadingProvider>
      <LoadingWrapper>
        <BuyProvider>
          <MusicProvider>
            <Head>
              <title>Qoncert</title>
              <meta property="og:title" content="Qoncert Shows" />
              <meta
                property="og:image"
                content={`${withBaseUrl("/assets/logo.webp")}`}
              />
              <meta property="og:type" content="website" />
            </Head>
            <Toaster
              position="top-center"
              toastOptions={{
                duration: 2000,
              }}
            />
            <Component {...pageProps} />
            <div style={{ zIndex: 1000, position: 'relative' }}>
              <GlobalMusicPlayer />
            </div>
          </MusicProvider>
        </BuyProvider>
      </LoadingWrapper>
    </LoadingProvider>
  );
}
